// Types
import { RootState } from 'types/RootState.types';

// Config
import { DISABLED_FEATURE } from '@constants/featureConstants';
import { isFeatureDisabled } from '@redux/reducers/config/configReducer';

const isPayPalAvailable = (state: RootState) => {
  const isDisabled = isFeatureDisabled(state, DISABLED_FEATURE.PAYPAL);

  return !isDisabled;
};

export default isPayPalAvailable;
